import(/* webpackMode: "eager" */ "/codebuild/output/src254889766/src/clientrazorswiftnet/src/app/(auth)/[company]/page.js")